<div class="container">
  <button (click)="toggleDisplay()" type="button">Prendre RDV pour une étude GRATUITE</button>
</div>
<div *ngIf="!isShow" class="infos">
  <p>06.34.72.49.33</p>
  <p>glenn.gendre@gmail.com</p>
</div>
